
import './InputBox.css';
import { forwardRef, useState, useEffect } from 'react';

const InputBox = forwardRef(({ id, classNameInput, classNameLabel, style, check, setValue, name, disabled, onClick}, ref) => {
    const [checked, setChecked] = useState(check);

    const handleChange = () => {
        setChecked(!checked)
        setValue(name, !checked)
        if (onClick != null) {
            onClick(!checked);
        }
    };
    
    useEffect(() => {
          setChecked(check)
    }, [check])
    return (
        <>
            <input ref={ref} className={"checkbox-spin " + (classNameInput ? classNameInput : '') + ""} type="checkbox" onChange={handleChange} checked={checked} id={id} disabled={disabled}/>
            <label style={style} className={ (classNameLabel ? classNameLabel : '') + ""} htmlFor={id}><span></span></label>
        </>

    )
});

InputBox.defaultProps = {
    check : false,
    setValue : () => {}
}

export default InputBox
